const state = {
    notifications: {},
    loaders: {},
}

const getters = {
    enabledNotifications: state => {
        const enabledNotifications = []

        for (const notificationId in state.notifications) {
            if (state.notifications[notificationId]) {
                enabledNotifications.push(notificationId)
            }
        }

        return enabledNotifications
    },
    enabledLoaders: state => {
        const enabledLoaders = []

        for (const loaderId in state.loaders) {
            if (state.loaders[loaderId]) {
                enabledLoaders.push(loaderId)
            }
        }

        return enabledLoaders
    }
}

const actions = {

}

const mutations = {
    enableLoader (state, id) {
        state.loaders = {
            ...state.loaders,
            [id]: true
        }
    },
    disableLoader (state, id) {
        state.loaders = {
            ...state.loaders,
            [id]: false
        }
    },
    enableNotification (state, { id, title, message, duration = null }) {
        state.notifications = {
            ...state.notifications,
            [id]: {
                title: title,
                message: message,
                duration: duration // optional duration
            }
        }
    },
    disableNotification (state, id) {
        state.notifications = {
            ...state.notifications,
            [id]: null
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
